import React from 'react';
import COLORS from 'constants/colors';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Row, Col, Text, Separator } from '@cuemath/comps';
import Rating from 'comps/rating';
import { Group } from 'styled-icons/material/Group';

import Options from './options';

const CONFIG_TYPES = {
  TEACHER_ISSUES: 'TEACHER_ISSUES',
  CURRICULUM_ISSUES: 'CURRICULUM_ISSUES',
};

const StyledCard = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 8px 12px;
`;

const InfoContainer = styled.div`
  margin-left: 18px;
`;

const SubHeader = styled(Text)`
  font-weight: 600;
`;

const StyledIcon = styled(Group)`
  color: ${COLORS.COLA};
  margin-right: 12px;
`;

const StyledCol = styled(Col)`
  @media (min-width: 769px) {
    padding: 12px 0px;
  }
`;

const ParentFeedback = ({ feedback, config }) => {
  const {
    curriculum_issues: curriculumIssues = [],
    curriculum_rating: curriculumRating = 0,
    suggestions,
    teacher_issues: teacherIssues = [],
    teacher_rating: teacherRating = 0,
  } = feedback || {};

  const { feedback: configFeedback } = config || {};
  const { form = [] } = configFeedback || {};

  const [teacherIssuesConfig] = form.filter(
    ({ rating_title: title }) => title === CONFIG_TYPES.TEACHER_ISSUES,
  );
  const [curriculumIssuesConfig] = form.filter(
    ({ rating_title: title }) => title === CONFIG_TYPES.CURRICULUM_ISSUES,
  );

  const { questions: teacherQuestions = [] } = teacherIssuesConfig || {};
  const { questions: curriculumQuestions = [] } = curriculumIssuesConfig || {};

  return (
    <div>
      <Row alignItems="center" nowrap>
        <StyledIcon size={36} />
        <Text size="larger" color={COLORS.COLA}>
          Parent Post-demo Feedback
        </Text>
      </Row>
      <Separator height={16} transparent />
      <Row>
        <Col sm={7} xs={12} gutter={0} gap={8}>
          <Row>
            <Col sm={6} xs={12} gutter={0} gap={4}>
              <SubHeader color={COLORS.COLA}>Teacher</SubHeader>
              <Separator height={4} transparent />
              <InfoContainer>
                <Rating value={teacherRating} />
                <Separator height={4} transparent />
                {teacherIssues.map(issues => {
                  const [question] =
                    teacherQuestions.filter(({ id }) => id === issues) || [];
                  const { value } = question || {};

                  return <Options key={value} value={value} />;
                })}
              </InfoContainer>
            </Col>
            <Col sm={6} xs={12} gutter={0} gap={4}>
              <SubHeader color={COLORS.COLA}>Platform and Curriculum</SubHeader>
              <Separator height={4} transparent />
              <InfoContainer>
                <Rating value={curriculumRating} />
                <Separator height={4} transparent />
                {curriculumIssues.map(issues => {
                  const [question] =
                    curriculumQuestions.filter(({ id }) => id === issues) || [];
                  const { value } = question || {};

                  return <Options key={value} value={value} />;
                })}
              </InfoContainer>
            </Col>
          </Row>
        </Col>
        <StyledCol sm={5} xs={12} gap={8} gutter={0}>
          <SubHeader color={COLORS.COLA}>Suggestions</SubHeader>
          <Separator height={4} transparent />
          <StyledCard>
            <Text color={COLORS.COLA}>{suggestions}</Text>
          </StyledCard>
        </StyledCol>
      </Row>
    </div>
  );
};

ParentFeedback.propTypes = {
  config: PropTypes.shape({}),
  feedback: PropTypes.shape({}),
};

ParentFeedback.defaultProps = {
  config: null,
  feedback: null,
};

export default ParentFeedback;
